import { XMarkIcon } from '@heroicons/react/24/outline'

export function CloseButton({ onClick }: { onClick: () => void }) {
  return (
    <div
      className="cursor-pointer text-gray-300 hover:text-gray-400"
      onClick={onClick}
    >
      <span className="sr-only">Close</span>
      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
    </div>
  )
}
